<template>
  <div class="csh">
    <div
      class="bar"
      :style="{ backgroundColor }"
    >
      <div class="status">
        {{ candidate.status.name }}
        <svg
          v-b-popover.html="{
            content: `Изменить статус`,
            trigger: 'hover blur',
            container: '#app',
            placement: 'top',
          }"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          @click="updateCandidateStatus"
        >
          <path
            d="M0 11.8123C0 12.3645 0.447715 12.8123 1 12.8123C1.55228 12.8123 2 12.3645 2 11.8123H0ZM1 8.81226V7.81226C0.447715 7.81226 0 8.25997 0 8.81226H1ZM4 9.81226C4.55228 9.81226 5 9.36454 5 8.81226C5 8.25997 4.55228 7.81226 4 7.81226V9.81226ZM14 1.8125C14 1.26022 13.5523 0.812502 13 0.812502C12.4477 0.812502 12 1.26022 12 1.8125H14ZM13 4.8125V5.8125C13.5523 5.8125 14 5.36479 14 4.8125H13ZM10 3.8125C9.44771 3.8125 9 4.26022 9 4.8125C9 5.36479 9.44771 5.8125 10 5.8125V3.8125ZM13.9256 9.18537C14.1079 8.66403 13.833 8.09365 13.3116 7.91139C12.7903 7.72913 12.2199 8.00401 12.0376 8.52536L13.9256 9.18537ZM2.98648 9.03626C2.74671 8.53874 2.14902 8.32979 1.6515 8.56956C1.15397 8.80933 0.945023 9.40702 1.18479 9.90455L2.98648 9.03626ZM0.574402 4.62713C0.392144 5.14848 0.667027 5.71886 1.18837 5.90112C1.70972 6.08338 2.2801 5.80849 2.46236 5.28715L0.574402 4.62713ZM11.5135 4.77624C11.7533 5.27377 12.351 5.48272 12.8485 5.24295C13.346 5.00318 13.555 4.40548 13.3152 3.90796L11.5135 4.77624ZM2 11.8123V8.81226H0V11.8123H2ZM1 9.81226H4V7.81226H1V9.81226ZM12 1.8125V4.8125H14V1.8125H12ZM13 3.8125H10V5.8125H13V3.8125ZM12.0376 8.52536C11.7174 9.44136 11.1327 10.2418 10.3576 10.8256L11.5607 12.4232C12.6518 11.6016 13.4748 10.4748 13.9256 9.18537L12.0376 8.52536ZM10.3576 10.8256C9.58242 11.4093 8.65157 11.75 7.68275 11.8047L7.79546 13.8015C9.15922 13.7245 10.4695 13.2449 11.5607 12.4232L10.3576 10.8256ZM7.68275 11.8047C6.71393 11.8594 5.75065 11.6256 4.91472 11.1328L3.89906 12.8557C5.07575 13.5494 6.43171 13.8785 7.79546 13.8015L7.68275 11.8047ZM4.91472 11.1328C4.07879 10.64 3.40776 9.91041 2.98648 9.03626L1.18479 9.90455C1.7778 11.135 2.72237 12.162 3.89906 12.8557L4.91472 11.1328ZM2.46236 5.28715C2.78259 4.37115 3.36725 3.57067 4.14241 2.98695L2.93932 1.38928C1.84817 2.21094 1.02517 3.33773 0.574402 4.62713L2.46236 5.28715ZM4.14241 2.98695C4.91758 2.40323 5.84843 2.06249 6.81725 2.0078L6.70454 0.0109785C5.34078 0.0879575 4.03048 0.567608 2.93932 1.38928L4.14241 2.98695ZM6.81725 2.0078C7.78607 1.95311 8.74935 2.18694 9.58528 2.67972L10.6009 0.956806C9.42425 0.26315 8.06829 -0.0660006 6.70454 0.0109785L6.81725 2.0078ZM9.58528 2.67972C10.4212 3.1725 11.0922 3.9021 11.5135 4.77624L13.3152 3.90796C12.7222 2.67747 11.7776 1.65046 10.6009 0.956806L9.58528 2.67972Z"
            fill="#8E9CBB"
          />
        </svg>
      </div>
      <div class="bar__row">
        <CandidatesStatusIcon
          class="status-icon"
          :scheduled-date-time="{ time: candidate.statusTime, date: candidate.statusDate }"
          :status="candidate.state"
        />
        <ScheduledDate
          v-if="candidateStatusScheduledDate"
          class="scheduled-date"
          :date="candidateStatusScheduledDate"
          :status-id="candidate.status.id"
        />
      </div>
      <div v-if="candidate.dateOfStatusChange" class="days-in-status">
        <svg
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: `Количество дней в статусе: ${getCalculatedDaysFromStatusChangeDate(
              candidate.dateOfStatusChange,
            )}`,
            placement: 'top',
          }"
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 1V3M4 1V3M2.77778 2H11.2222C12.2041 2 13 2.79594 13 3.77778V10.2222C13 11.2041 12.2041 12 11.2222 12H2.77778C1.79594 12 1 11.2041 1 10.2222V3.77778C1 2.79594 1.79594 2 2.77778 2Z"
            stroke="#8E9CBB"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>{{ getCalculatedDaysFromStatusChangeDate(candidate.dateOfStatusChange) }}</span>
      </div>
      <div v-if="candidate.status.comment" class="status-comment">
        <svg
          class="c-button-icon_stroked"
          width="15"
          height="15"
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.4647 1.00024H2.49575C1.67075 1.00024 1 1.67099 1 2.49599V9.47673C1 10.3017 1.67075 10.9725 2.49575 10.9725H5.98612V14.7191C5.98612 14.9481 6.24787 15.0813 6.43251 14.9458L9.97501 10.9725H13.4647C14.2897 10.9725 14.9604 10.3017 14.9604 9.47673V2.49599C14.9604 1.67099 14.2897 1.00024 13.4647 1.00024Z"
            stroke="#8E9CBB"
            stroke-width="2"
          />
        </svg>
        <div class="status-comment__comment">
          {{ candidate.status.comment }}
        </div>
        <span
          class="status-comment__button"
          @click="openCommentModal(candidate.status.comment)"
        >
          Показать
        </span>
      </div>
      <div class="accountable">
        <img height="34" width="34" :src="accountableAvatar" />
        <div class="accountable__info">
          <a
            v-if="candidate.accountable"
            :href="linkToWorker"
            target="_blank"
            class="accountable__name"
          >
            {{ candidate.accountable.name }}
          </a>
          <div v-else>Не назначен</div>
          <div class="accountable__label">Ответственный за кандидата</div>
        </div>
      </div>
    </div>
    <div class="header">
      <div class="header__employee">
        <div v-viewer class="header__employee__avatar">
          <img :src="candidate.photo ? candidate.photo : defaultAvatar" @error="replaceImageOnErrorLoad" />
        </div>
        <div class="header__employee__info">
          <div class="header__employee__info__fullname">
            <div class="header__employee__info__fullname__text">
              {{ candidate.fio }}
            </div>
            <CandidatesWorksheetStatus
              :candidate="candidate"
              :with-link="!personal"
            />
            <CandidatesSourceIcon :source-id="candidate.source.id" />
          </div>
          <div class="header__employee__info__block">
            <div v-if="candidate.post" class="header__employee__info__position">
              <div>{{ candidate.post }}</div>
            </div>
            <div v-if="candidate.filial" class="header__employee__info__filial">
              {{ candidate.filial.filial_name }}
            </div>
            <div v-if="candidate.phone  || candidate.email" class="header__employee__info__phone-and-email">
              {{ `${candidate.phone}` }}<span v-if="candidate.email">, {{ `${candidate.email}` }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="header__buttons">
        <BubbleComment
          v-if="candidateComment"
          :edit-permission="true"
          class="header__buttons__top__comment__bubble"
          @goToPreview="openCommentModal(candidateComment)"
          @goToEdit="displayWorkerCommentModal = true"
        >
          {{ candidateComment }}
        </BubbleComment>
        <Button
          v-else
          size="small"
          icon="comment"
          @click="displayWorkerCommentModal = true"
        />
      </div>
      <div class="layout-header-action-dropdown head__actions">
        <div
          class="c-button__dropdown__container__overlay"
          :class="{
            'c-button__dropdown__container__overlay__active': isActiveDropdown,
          }"
          @click="isActiveDropdown = false"
        />
        <div class="c-button c-button_with-icon c-button_responsive">
          <div
            class="c-button__wrapper"
            :class="{ 'c-button__wrapper__active': isActiveDropdown }"
            @click="isActiveDropdown = !isActiveDropdown"
          >
            <div class="c-button__label__left">Действия</div>
            <div class="c-button__icon__right">
              <Icon icon="arrow" />
            </div>
            <div
              class="c-button__dropdown__container c-button__dropdown__container__left"
              :class="{
                'c-button__dropdown__container__active': isActiveDropdown,
              }"
            >
              <div class="c-button__dropdown__container__list">
                <div
                  v-if="!personal"
                  class="c-button__dropdown__container__list__item" @click="goToWorksheet"
                >
                  <CandidatesWorksheetStatus :candidate="candidate" />
                  <div class="c-button__dropdown__container__list__item__label">Анкета кандидата</div>
                </div>
                <div class="c-button__dropdown__container__list__item" @click="edit">
                  <Icon icon="edit" />
                  <div class="c-button__dropdown__container__list__item__label">Редактировать</div>
                </div>
                <div class="c-button__dropdown__container__list__item" @click="deleteCandidate">
                  <Icon icon="trash" color="secondary" />
                  <div class="c-button__dropdown__container__list__item__label">Удалить</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CandidateChangeStatus
      ref="changeStatusModal"
      :candidate-data="candidate"
    />
    <CommentModal ref="commentModal" />
    <WorkerCommentModal
      v-if="displayWorkerCommentModal"
      ref="workerCommentModal"
      :comment="candidateComment"
      :handle-save-outside="true"
      @on-save="onCommentSave"
      @close="displayWorkerCommentModal = false"
    />
    <Confirm ref="confirm" mode="danger" />
  </div>
</template>

<script>

import { calculateDaysFromNowTo, reformatDateForServer } from "@/helpers/workWithDates";

import CandidatesStatusIcon from "@/pages/staff/candidates/components/candidates-status-icon";
import ScheduledDate from "@/pages/staff/candidates/components/candidates-scheduled-date";
import CandidateChangeStatus from "@/components/modals/candidate-change-status";
import CandidatesSourceIcon from "@/pages/staff/candidates/components/candidates-source-icon";
import CandidatesWorksheetStatus from "@/pages/staff/candidates/components/candidates-worksheet-status";
import WorkerCommentModal from "@/pages/personal-employee/additions/modals/worker-comment-modal";
import CommentModal from "@/components/modals/comment-modal";
import Confirm from "@/components/modals/confirm-modal";
import BubbleComment from "@/components/bubbleComment";
import Button from "@/components/controls2/Button";
import Icon from "@/components/icon";

import defaultAvatar from "@/assets/images/userpic.svg";
import noAccountableAvatar from "@/assets/images/question-sign.svg";

import candidateStatusMixin from "@/mixins/candidateStatusMixin";

const dropdownItems = [
  {
    label: "Анкета кандидата",
    icon: "",
  },
  {
    label: "Удалить",
    icon: "trash",
    iconColor: "secondary",
  },
];

export default {
  components: {
    ScheduledDate,
    CandidatesStatusIcon,
    CandidatesSourceIcon,
    CandidateChangeStatus,
    CommentModal,
    Button,
    Icon,
    CandidatesWorksheetStatus,
    BubbleComment,
    WorkerCommentModal,
    Confirm,
  },
  mixins: [candidateStatusMixin],
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    personal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isActiveDropdown: false,
    displayWorkerCommentModal: false,
    candidateComment: "",
    candidateWithMetaCrutch: {},
    dropdownItems,
    defaultAvatar,
  }),
  computed: {
    backgroundColor() {
      const backgroundColor = this.getStatusColor(this.candidate.status.id);

      if (!backgroundColor) {
        return "#dfe4ef";
      }

      return backgroundColor;
    },
    accountableAvatar() {
      if (this.candidate.accountable) {
        return this.candidate.accountable.photo ? this.candidate.accountable.photo : defaultAvatar;
      }
      return noAccountableAvatar;
    },
    candidateStatusScheduledDate() {
      if (!this.candidate.statusTime && !this.candidate.statusDate) {
        return "";
      }

      return `${this.candidate.statusDate} ${this.candidate.statusTime}`;
    },
    linkToWorker() {
      if (!this.candidate.accountable) {
        return "#";
      }

      return `/?r=redesign#/personal-employee/${this.candidate.accountable.id}/summary`;
    },
  },
  mounted () {
    this.candidateComment = this.candidate.comment;
  },
  methods: {
    updateCandidateStatus() {
      this.$refs.changeStatusModal.open();
    },
    openCommentModal(comment) {
      this.$refs.commentModal.open(comment);
    },
    getCalculatedDaysFromStatusChangeDate(dateOfStatusChange) {
      const days = calculateDaysFromNowTo(reformatDateForServer(dateOfStatusChange));
      return `${days} дн.`;
    },
    goToWorksheet() {
      this.$router.push({
        name: "candidates-profile",
        params: {
          id: this.candidate.id,
        },
      });
    },
    deleteCandidate() {
      const candidateId = this.candidate.id;
      const candidateStatusId = this.candidate.status.id;

      this.$refs.confirm.open({
        title: "Удаление кандидата",
        text: `Кандидат <b>${this.candidate.fio}</b> будет удален без возможности восстановления`,
        confirm: "Удалить",
        onConfirm: () => {
          this.$store.dispatch("candidates/deleteCandidate", candidateId);
          this.$emit("on-candidate-delete", { candidateId, candidateStatusId });
          this.$emit("close")
          //this.closeSidesheet();
        },
      });
    },
    replaceImageOnErrorLoad(e) {
      e.target.src = defaultAvatar;
    },
    edit() {
      const url = `index.php?r=candidate%2Fupdate&id=${this.candidate.id}&choose_cand=1`;
      window.open(url, "_blank");
    },
    onCommentSave(comment) {
      this.$store.dispatch("candidates/saveCandidateComment", {
        candidateId: this.candidate.id,
        candidateComment: comment,
      });

      this.candidateComment = comment;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.bar {
  display: flex;
  align-items: center;
  padding: 0 30px;
  margin-bottom: 20px;
  height: 50px;
  font-size: 12px;

  @include onlyMobile {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    padding: 15px 20px;
    margin-bottom: 15px;
    gap: 12px;

    > * {
      margin: 0;
    }
  }

  &__row {
    display: flex;
    align-items: center;

    @include onlyMobile {
      align-items: stretch;

      > * {
        margin: 0;
      }
    }
  }
}

.status {
  font-weight: 500;
  font-size: 15px;
  margin-right: 30px;

  & svg {
    margin-left: 10px;
    cursor: pointer;
  }
}

.status-icon {
  margin-right: 11px;
}

.scheduled-date {
  margin-right: 30px;
  & /deep/ .c-icon {
    margin-top: 1px;
  }
}

.days-in-status {
  display: flex;
  align-items: center;
  font-size: 11px;
  margin-right: 30px;

  & span {
    margin-top: 3px;
    margin-left: 5px;
  }
}

.status-comment {
  display: flex;
  flex: 1;
  min-width: 0;
  align-items: center;
  margin-right: 30px;

  & svg {
    flex-shrink: 0;
  }

  &__comment {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin: 0 8px;
  }
  
  &__button {
    cursor: pointer;
    flex-shrink: 0;
    color: $color-primary-hover;
  }
}

.accountable {
  margin-left: auto;
  display: flex;
  align-items: center;

  @include onlyMobile {
    margin-left: 0;
  }

  & > img {
    border-radius: 100%;
    object-fit: cover;
  }

  &__info {
    margin-left: 9px;
    line-height: 1.08;
  }

  &__name {
    font-weight: 500;
  }

  &__label {
    color: $color-label;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  width: 100%;

  & /deep/ {
    .candidates-worksheet-status-icon {
      width: 28.5px;

      & svg {
        margin-left: 4px;
        transform: none !important;
      }
    }
  }

  @include onlyMobile {
    justify-content: flex-start;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
  }

  @media screen and (max-width: 700px) {
    margin-bottom: 9px;
    flex-wrap: wrap;
  }

  &__employee {
    display: flex;
    align-items: center;

    @include onlyMobile {
      width: 100%;
    }

    &__avatar {
      cursor: pointer;
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      margin-right: 20px;

      & img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }

      @media screen and (max-width: 768px) {
        align-self: flex-start;
        width: 52px;
        height: 52px;
        flex-shrink: 0;
      }

      @media screen and (max-width: 700px) {
        margin-right: 13px;
      }
    }

    &__info__block {
      display: flex;
      flex-direction: column;

      @media screen and (max-width: 700px) {
        margin-bottom: 13px;
        margin-top: 20px;
        margin-left: -65px;
      }
    }

    &__info {
      display: flex;
      flex-direction: column;

      @include onlyMobile {
        flex-grow: 1;
      }

      &__fullname {
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 22px;
        line-height: 108%;
        margin-bottom: 9px;
        margin-right: 20px;

        &__text {
          margin-right: 8px;
        }

        @media screen and (max-width: 768px) {
          margin-bottom: 5px;
          font-size: 18px;
          margin-right: 11px;
          min-height: 52px;

          &__text {
            max-width: 300px;
            overflow-wrap: break-word;
          }
        }

        @media screen and (max-width: 500px) {
          &__text {
            overflow-wrap: normal;
            word-break: break-all;
          }
        }

        @include onlyMobile {
          &__text {
            max-width: 150px;
            margin-right: auto;
          }
        }

        &__worksheet__status {
          cursor: pointer;
          margin-left: 14px;

          @media screen and (max-width: 500px) {
            margin-right: 14px;
          }
        }
      }

      &__filial {
        font-size: 13px;
        line-height: 120%;

        @media screen and (max-width: 768px) {
          margin-right: 15px;
        }
      }

      &__position {
        display: flex;
        font-weight: 500;
        line-height: 1.2;

        &__names {
          list-style-type: none;
          margin: 0;
          padding: 0;
          margin-top: 2px;

          @media screen and (max-width: 700px) {
            margin-top: 3px;
          }

          &__item {
            font-size: 13px;
            line-height: 137%;
            max-width: 300px;
            //margin-bottom: 2px;

            @media screen and (max-width: 768px) {
              margin-right: 10px;
            }

            @media screen and (max-width: 700px) {
              max-width: 100%;
            }

            &__icon {
              vertical-align: text-bottom;
              display: inline-block;
              margin-left: 6px;

              ::v-deep & svg:focus {
                outline: none !important;
                box-shadow: none !important;
              }
            }
          }
        }
      }

      &__phone-and-email {
        margin-top: 6px;
        display: flex;

        & a {
          color: $black;
          margin-left: 5px;
        }
      }
    }
  }

  &__buttons {
    display: flex;
    margin-left: auto;

    @media screen and (max-width: 700px) {
      margin-top: 0;
      margin-bottom: 12px;
    }

    @include onlyMobile {
      margin-left: 0;
    }

    & /deep/ button {
      margin-right: 11px;
    }

    &__top {
      margin-right: 11px;

      &__comment__mobile {
        @media screen and (min-width: 769px) {
          display: none;
        }
      }

      &__comment__bubble {
        margin-right: 29px;

        @media screen and (max-width: 768px) {
          display: none;
        }
      }
    }
  }
}

svg {
  outline: none;
}

.c-button__dropdown__container {
  width: 243px;

  &__list__item {
    padding: 0 13px;
  }
}
</style>